import { render, staticRenderFns } from "./daily-task.vue?vue&type=template&id=9dd3ffac&scoped=true"
import script from "./daily-task.vue?vue&type=script&lang=js"
export * from "./daily-task.vue?vue&type=script&lang=js"
import style0 from "./daily-task.vue?vue&type=style&index=0&id=9dd3ffac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd3ffac",
  null
  
)

export default component.exports